export default function CarouselType() {
  return <>CarouselType</>;
}
